import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: []
  }),
  actions: {
    notify(message, type = 'info', timeout = 5000) {
      const id = Date.now()
      this.notifications.push({
        id,
        message,
        type, // 'success', 'error', 'info'
        visible: true
      })

      if (timeout > 0) {
        setTimeout(() => {
          this.removeNotification(id)
        }, timeout)
      }
    },
    success(message, timeout = 5000) {
      this.notify(message, 'success', timeout)
    },
    error(message, timeout = 5000) {
      this.notify(message, 'error', timeout)
    },
    info(message, timeout = 5000) {
      this.notify(message, 'info', timeout)
    },
    removeNotification(id) {
      const index = this.notifications.findIndex(n => n.id === id)
      if (index !== -1) {
        // First mark as invisible to trigger transition
        this.notifications[index].visible = false
        // Then remove after transition
        setTimeout(() => {
          const actualIndex = this.notifications.findIndex(n => n.id === id)
          if (actualIndex !== -1) {
            this.notifications.splice(actualIndex, 1)
          }
        }, 300)
      }
    }
  }
})
